
import Vue from 'vue'
import AppActions from '~/domain/constants/AppActions'
export default Vue.extend({
  data() {
    return {
      appUrl: this.$config.nuxtBaseURL,
      valid: true,
      formIsBusy: false,
      formSubmitted: false,
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        checkboxDemoRequest: false,
        checkboxSubscribe: false,
      },
      formRules: {
        nameRules: [
          (v) => !!v || this.$t('nameRequired'),
          (v) => (v && v.length >= 3) || this.$t('nameAtLeast3Chars'),
        ],
        emailRules: [
          (v) => !!v || this.$t('emailRequired'),
          (v) => /.+@.+\..+/.test(v) || this.$t('mailMustBeValid'),
        ],
        companyRules: [
          (v) => !!v || this.$t('companyRequired'),
        ],
      },
      pdf: "/download/LiveOps_Z0G69UPPP2SCXsEjnRInke2KicEE9WWj.pdf",
      filename: 'LiveOps - Turning Chaos into Predictive Clarity.pdf'
    }
  },
  methods: {
    async handleSubmit() {
      if (this.$refs.form) {
        const formIsValid = (this.$refs.form as any).validate()

        if (formIsValid) {

          (this.$refs.download as HTMLAnchorElement).href = this.pdf as string
          (this.$refs.download as HTMLAnchorElement).download = this.filename as string

          this.formIsBusy = true
          try {
            // call action to send e-mail
            const result = await this.$store.dispatch(
                'common/sendLiveopsWhitepaperEmail',
                {
                  context: this,
                  params: {
                    email: this.formData.email,
                    firstName: this.formData.firstName,
                    lastName: this.formData.lastName,
                    company: this.formData.company,
                    demoRequest: this.formData.checkboxDemoRequest,
                    subscribe: this.formData.checkboxSubscribe
                  },
                }
            )
            if (result.success) {
              this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
                context: this,
                params: {
                  name: 'Whitepaper - Download',
                  category: 'Microconversion',
                  action: 'Whitepaper',
                  label: 'liveops whitepaper download',
                  misc: [
                    {
                      type: 'location',
                      value: 'liveops_whitepaper',
                    },
                  ],
                },
              })
              //@ts-ignore
              await this.$refs.form.reset()
              this.formSubmitted = true

            } else {
              this.$store.commit('common/setFormSubmitError', true);
            }
            this.formIsBusy = false
          } catch (error) {
            this.formIsBusy = false
            this.formSubmitted = false
          } finally {
            this.formIsBusy = false
          }
        }
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('common/setFormSubmitError', false);
  },
})
